// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'; // Import Provider
import store from './store'; // Import Redux store
import App from './App';

// Disable browser spell checking globally
if (typeof document !== 'undefined') {
    document.body.setAttribute('spellcheck', 'false');
}

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);